import Profile from './profile.i18n';

export default Profile